import { render, staticRenderFns } from "./SiderMenu.vue?vue&type=template&id=6a574f93&"
import script from "./SiderMenu.vue?vue&type=script&lang=js&"
export * from "./SiderMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiderMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports